














































import {Component, Prop, Vue} from 'vue-property-decorator';
import {Post} from '@/models/post';
import PostInfo from '@/components/PostInfo.vue';
import PostCategory from '@/components/PostCategory.vue';
@Component({
  components: {PostCategory, PostInfo},
})
export default class BlogSummaryCard extends Vue {
  @Prop()
  private post!: Post;
}
